
import { defineComponent } from "vue";

import { FormFieldCheckbox } from "@tager/admin-ui";

import { getCategoryFormUrl } from "@/utils/paths";

import ThroughNavigationTable from "./ThroughNavigationTable/ThroughNavigationTable.vue";

export default defineComponent({
  name: "ThroughNavigation",
  components: { FormFieldCheckbox, ThroughNavigationTable },
  props: {
    values: {
      type: Object,
      required: true,
    },
    categoryOptionList: {
      type: Array,
      required: true,
    },
  },
  setup() {
    return {
      getCategoryFormUrl,
    };
  },
});
